import React from "react";
import { Link } from "react-scroll";
import "./ProductImage.scss";
const ProductImage = () => {
  return (
    <div id="top-desktop">
      <Link to="video" smooth={true} duration={500}>
        <img src="propozycja podania.png" alt="produkt" />
      </Link>
    </div>
  );
};

export default ProductImage;
